import script from "./VecuraPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VecuraPage.vue?vue&type=script&setup=true&lang=ts"

import "./VecuraPage.vue?vue&type=style&index=0&id=030f895e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030f895e"]])

export default __exports__